import React from "react";
import { BaseModel, Issue, UnknownArrival } from "src/types";
import { NoteDisplay } from "src/components";

interface UnknownArrivalDetailsSectionsProps extends Omit<UnknownArrival, keyof BaseModel | keyof Issue> {}

const UnknownArrivalDetailsSections: React.FC<UnknownArrivalDetailsSectionsProps> = ({
  reasonForUnknownArrival,
  additionalDetails
}) => {
  return (
    <section className="pb-7.5 bg-white mb-3.5 max-w-[1000px]">
      <div>
        {reasonForUnknownArrival && (
          <div>
            <h2>Reason for unknown arrival:</h2>
            <NoteDisplay note={{ body: reasonForUnknownArrival, date: "" }} />
          </div>
        )}
        {additionalDetails && (
          <div className="leading-[3]">
            <div>Additional Details:</div>
            <NoteDisplay note={{ body: additionalDetails, date: "" }} />
          </div>
        )}
      </div>
    </section>
  );
};

export { UnknownArrivalDetailsSections };
